import React from 'react';
import cx from 'classnames';

var PureRenderMixin = React.addons.PureRenderMixin;

var sizeMap = {
  'xx-small': 12,
  'x-small': 14,
  'small': 20,
  'medium': 28,
  'large': 36,
  'x-large': 44
};

var Icon = React.createClass({
  mixins: [PureRenderMixin],

  getDefaultProps() {
    return {
      size: 'medium',
      pack: 'ofs-icons',
      variant: null
    };
  },

  render() {
    var {glyph, pack, size, variant, ...props} = this.props;

    var classes = cx({
      'ofs-Icon': true,
      [`ofs-Icon--${ glyph }`]: true,
      [`ofs-Icon--${ glyph }-${ variant }`]: variant,
      [`ofs-Icon--${ size }`]: true
    });

    return (
      <div className={classes} {...props}>
        <svg className="ofs-Icon__Container" dangerouslySetInnerHTML={{__html:
          `<use xlink:href=\"#${ pack }--${ glyph }-${ sizeMap[size] }\"></use>`
        }} />
      </div>
    );
  }
});

export default Icon;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/common/Icon.jsx
 **/